export default "__VITE_ASSET__CtwuxHfT__"